import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import Props from '@/components/app/product/components/digipay-badge/type';

import imagesList from '@/constant/images-list';

export default function SnappPayBadge({ icon, title, description }: Props) {
  return (
    <Container className='flex items-center! justify-start gap-3 pt-0.5 pr-[18px] pb-4'>
      <Container>
        <XImage
          src={icon?.publicLink || imagesList.icons?.snappPayBlue}
          alt='snapp-pay'
          width={40}
          height={40}
        />
      </Container>
      <Container className='h-[41px]'>
        <Text
          className='leading-[22px]! font-bold! tracking-[-0.08em] text-[#1A1C23]'
          bold
          size={SIZE_ENUM.XS}
        >
          {title}
        </Text>
        <Text
          className='leading-[22px]! tracking-[-0.08em] text-[#616475]'
          size={SIZE_ENUM.XXS}
        >
          {description}
        </Text>
      </Container>
    </Container>
  );
}
